import { BasicSuccessPage } from "@component/assets/AbstractLeadForm/Steps/BasicSuccessPage";
import { faCircleCheck as fasCircleCheck } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export class SuccessPage extends BasicSuccessPage {
	protected renderContent(): ReactNode {
		const { title, feedBackEmail } = this.props;

		return (
			<>
				<Card.Header>
					<Card.Title className="text-center text-white">{title}</Card.Title>
				</Card.Header>
				<Card.Body className="d-flex flex-column justify-content-center text-white">
					<div className="d-flex px-3 py-2 border-bottom">
						<div className="text-center my-auto ml-auto">
							<FontAwesomeIcon icon={fasCircleCheck} className="text-gold" size="4x" />
						</div>
						<div className="font-weight-bold my-auto mr-auto ml-3">
							Hamarosan elküldjük neked a kalkulációd eredményeit
						</div>
					</div>
					<div className="text-center py-2">
						Ha addig is további kérdésed lenne, írj nekünk a{" "}
						<a className="text-reset" href={`mailto:${feedBackEmail}`}>
							{feedBackEmail}
						</a>{" "}
						címre.
					</div>
				</Card.Body>
				{this.renderSubscribe()}
			</>
		);
	}

	protected renderSubscribeList(): ReactNode {
		return (
			<>
				<List.Item>
					<strong>Legfontosabb változások</strong> a hitel és megtakarítási lehetőségek piacán
				</List.Item>
				<List.Item>Hogyan spórolhatsz bankköltségeiden</List.Item>
				<List.Item>
					<strong>Ötletek, javaslatok</strong> hogyan hozz ki többet anyagi helyzetedből
				</List.Item>
			</>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.SuccessPage`;
	}
}
